// src/App.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FiHome, FiFileText, FiHelpCircle, FiBook, FiFolder } from 'react-icons/fi';
import Submit from './pages/Submit';
import Browse from './pages/Browse';
import Glossary from './pages/Glossary';
import Resources from './pages/Resources';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('submit');

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        {/* Header */}
        <header className="bg-white shadow">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="text-3xl">🚪</div>
                <h1 className="text-2xl font-bold text-gray-900">AK Doors FAQ System</h1>
              </div>
              <p className="text-gray-600">Internal Team Portal</p>
            </div>
          </div>
        </header>

        {/* Navigation Tabs */}
        <nav className="bg-white border-b border-gray-200 sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex gap-8">
              <Link
                to="/submit"
                onClick={() => setActiveTab('submit')}
                className={`py-4 px-2 border-b-2 font-medium text-sm ${
                  activeTab === 'submit'
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <FiFileText />
                  Submit Question
                </div>
              </Link>
              <Link
                to="/browse"
                onClick={() => setActiveTab('browse')}
                className={`py-4 px-2 border-b-2 font-medium text-sm ${
                  activeTab === 'browse'
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <FiHelpCircle />
                  Browse FAQs
                </div>
              </Link>
              <Link
                to="/glossary"
                onClick={() => setActiveTab('glossary')}
                className={`py-4 px-2 border-b-2 font-medium text-sm ${
                  activeTab === 'glossary'
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <FiBook />
                  Glossary
                </div>
              </Link>
              <Link
                to="/resources"
                onClick={() => setActiveTab('resources')}
                className={`py-4 px-2 border-b-2 font-medium text-sm ${
                  activeTab === 'resources'
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <FiFolder />
                  Resources
                </div>
              </Link>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/submit" element={<Submit />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/" element={<Submit />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 mt-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center text-gray-600">
            <p>© 2024 AK Doors. Have questions? Submit them above!</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
